import {withTranslation} from 'react-i18next'
import {getEventDateInformation} from '../../../../../../../commons/selectors/event'
import {
  getListImageOpacity,
  getListImagePosition,
  getListLocationAndDateFormat,
} from '../../../../../../../commons/selectors/settings'
import {getEventById} from '../../../../../../selectors/events'
import {
  isDescriptionVisible,
  isFullDateVisible,
  isImageVisible,
  isLocationVisible,
  isMembersVisible,
  isSocialShareVisible,
} from '../../../../../../selectors/list-settings'
import {getComponentConfig, isRibbonVisible} from '../../../../../../selectors/settings'
import {getShareFontSize} from '../../../../../../utils/calendar'
import {AppProps} from '../../../../../app/interfaces'
import {connect} from '../../../../../runtime-context/connect'
import {MonthlyCalendarEventDetailsOwnProps, MonthlyCalendarEventDetailsRuntimeProps} from './interfaces'
import {MonthlyCalendarEventDetails as MonthlyCalendarEventDetailsPresentation} from './monthly-calendar-event-details'

const mapRuntime = (context: AppProps): MonthlyCalendarEventDetailsRuntimeProps => {
  const {state, actions} = context
  const event = getEventById(state, state.calendarLayout.monthly.selectedEventId)

  const componentConfig = getComponentConfig(state)
  const {week, weekDayIndex} = context.state.calendarLayout.monthly.selectedDate
  const day = context.state.calendarLayout.weeks[week][weekDayIndex]

  return {
    event,
    dayEventCount: day.events.length,
    dateText: day.dayMonthText,
    showImage: Boolean(event.mainImage) && isImageVisible(state),
    showLocation: isLocationVisible(state),
    imagePosition: getListImagePosition(componentConfig),
    imageOpacity: getListImageOpacity(componentConfig),
    showFullDate: isFullDateVisible(state),
    showDescription: isDescriptionVisible(state),
    showShare: isSocialShareVisible(state),
    showMembers: isMembersVisible(state, event),
    locationAndDateFormat: getListLocationAndDateFormat(componentConfig),
    fullDate: getEventDateInformation(state, event.id).fullDate,
    shareFontSize: parseInt(getShareFontSize(context), 10),
    showRibbon: isRibbonVisible(state, event),
    closeMonthlyCalendarPopup: () => actions.closeMonthlyCalendarPopup(),
    closeMonthlyCalendarEvent: () => actions.closeMonthlyCalendarEvent(),
  }
}

export const MonthlyCalendarEventDetails = connect<
  MonthlyCalendarEventDetailsOwnProps,
  MonthlyCalendarEventDetailsRuntimeProps
>(mapRuntime)(withTranslation()(MonthlyCalendarEventDetailsPresentation))
export * from './interfaces'
